import { render, staticRenderFns } from "./WeForest.vue?vue&type=template&id=df4ffd82&scoped=true&"
import script from "./WeForest.vue?vue&type=script&lang=js&"
export * from "./WeForest.vue?vue&type=script&lang=js&"
import style0 from "./WeForest.vue?vue&type=style&index=0&id=df4ffd82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4ffd82",
  null
  
)

export default component.exports